export default __webpack_public_path__ + "static/media/img-0815-czech-republic-half-face.149a91be.png";